import { Component, Input } from '@angular/core';
import { CSSProperties } from '../../../models/styles.interfaces';
import { BaseProperties } from '../../../models/ui.interfaces';
import { VisibilityConfig } from '../label-with-icon/models/label-with-icon.interfaces';
import { BannerHeadingConfig } from './models/heading.interface';

/**
 * This component is responsible to create dynamic header tag based
 * on the level input with visiblity configuration and custom styling attributes.
 */
@Component({
  selector: 'idp-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss']
})
export class HeadingComponent
  implements
    BaseProperties<VisibilityConfig, BannerHeadingConfig, CSSProperties>
{
  /**
   * This consist of two properties text and optional level.
   * text is the content of heading and level tells the component which tag
   * it should use.
   */
  @Input() content = {} as BannerHeadingConfig;
  /**
   * This is the primary configuration for this component.
   * You can enable/disable this according to the use case by
   * passing visible props
   */
  @Input() config = {} as VisibilityConfig;
  /** This holds style properties. You can set apply styling according to the use case. */
  @Input() styles = {} as CSSProperties;

  constructor() {
    this.initDefaultValues();
  }

  /** Set default properties for config, content and styles */
  initDefaultValues() {
    this.content = {
      text: '',
      level: '3'
    };
    this.config = {
      visible: true
    };
    this.styles = {
      position: 'left',
      fontWeight: 'normal'
    };
  }

  /** prepare heading class according to the position */
  get headingClass(): string {
    const { fontWeight } = this.styles;
    return `${
      this.styles.position
        ? 'text-align-' + this.styles.position
        : 'text-align-left'
    } text-weight--${fontWeight}`;
  }
}
